import React from 'react'
import { Carousel } from 'react-bootstrap'
import { images } from '../images/images'

const Home = () => {
    return (
        <section className="home text-center">
            {/* Carousel Section */}
            <Carousel variant="dark" className="paddingStyle">
                {images.map((img, index) => (
                    <Carousel.Item key={index}>
                        <img
                            src={img}
                            className="carouselItem d-block w-100"
                            alt={`Slide ${index + 1}`}
                            loading="lazy"
                        />
                    </Carousel.Item>
                ))}
            </Carousel>

            {/* Vision & Mission Section */}
            <div className="missionVision">
                <div className="missionVision-card">
                    <h3>Our Vision</h3>
                    <p>
                        To serve as a catalyst for social, economic, and moral
                        transformation in ailing urban and rural communities.
                    </p>
                </div>

                <div className="missionVision-card">
                    <h3>Our Mission</h3>
                    <p>
                        To empower individuals and families in urban and rural
                        communities by creating awareness, providing guidance,
                        offering opportunities, and delivering relief during
                        emergencies—ensuring a peaceful and sustainable future.
                    </p>
                </div>
            </div>
        </section>
    )
}

export default Home
